const restaurantContext = require.context('./', false, /\.mdx$/);

export const restaurantPages = restaurantContext.keys().map((filePath) => {
  const module = restaurantContext(filePath);
  return { ...module.metadata, Component: module.default };
});

export const restaurantBySlug = Object.fromEntries(restaurantPages.map((page) => [page.slug, page]));
